import $ from 'jquery'
import Swiper from 'swiper'

// bens says: if you add a swiper module here
// - remember to add the module in the styles.sass as well!
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
Swiper.use([Autoplay, Navigation, Pagination])

export default class cockpitStageSlider {
  constructor (element) {
    this.$element = $(element)
    this.$slider = this.$element.find('.swiper')

    // Options
    this.loop = !!this.$element.data('loop')
    this.autoplayEnabled = !!this.$element.data('autoplay')
    this.autoplayDuration = (parseInt(this.$element.data('autoplayDuration'), 10) || 5) * 1000
    this.direction = 'horizontal'
    this.useNavigation = !!this.$element.data('useNavigation')
    this.usePagination = !!this.$element.data('usePagination')
    this.initializeSwiper()
  }

  initializeSwiper () {
    const swiperOptions = {
      direction: this.direction,
      loop: this.loop,
      autoplay: false,
      navigation: false,
      pagination: false
    }

    if (this.autoplayEnabled) {
      swiperOptions.autoplay = {
        disableOnInteraction: true,
        pauseOnMouseEnter: true,
        delay: this.autoplayDuration
      }
    }

    if (this.useNavigation) {
      swiperOptions.navigation = {
        nextEl: this.$slider.find('.swiper-button-next').get(0),
        prevEl: this.$slider.find('.swiper-button-prev').get(0)
      }
    }

    if (this.usePagination) {
      swiperOptions.pagination = {
        el: this.$slider.find('.swiper-pagination').get(0)
      }
    }

    this.swiper = new Swiper(this.$slider.get(0), swiperOptions)
  }
}
